export default __webpack_public_path__ + "static/media/38.20378765.jpg";